/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalUserStatus } from './ExternalUserStatus';
import {
    ExternalUserStatusFromJSON,
    ExternalUserStatusFromJSONTyped,
    ExternalUserStatusToJSON,
    ExternalUserStatusToJSONTyped,
} from './ExternalUserStatus';

/**
 * 
 * @export
 * @interface ExternalUserResponse
 */
export interface ExternalUserResponse {
    /**
     * 
     * @type {string}
     * @memberof ExternalUserResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserResponse
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserResponse
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserResponse
     */
    mfaPhoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserResponse
     */
    organizationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserResponse
     */
    organizationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserResponse
     */
    organizationForm?: string | null;
    /**
     * 
     * @type {ExternalUserStatus}
     * @memberof ExternalUserResponse
     */
    status?: ExternalUserStatus;
}



/**
 * Check if a given object implements the ExternalUserResponse interface.
 */
export function instanceOfExternalUserResponse(value: object): value is ExternalUserResponse {
    return true;
}

export function ExternalUserResponseFromJSON(json: any): ExternalUserResponse {
    return ExternalUserResponseFromJSONTyped(json, false);
}

export function ExternalUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'mfaPhoneNumber': json['mfaPhoneNumber'] === undefined ? undefined : json['mfaPhoneNumber'] === null ? null : json['mfaPhoneNumber'],
        'organizationName': json['organizationName'] === undefined ? undefined : json['organizationName'] === null ? null : json['organizationName'],
        'organizationNumber': json['organizationNumber'] === undefined ? undefined : json['organizationNumber'] === null ? null : json['organizationNumber'],
        'organizationForm': json['organizationForm'] === undefined ? undefined : json['organizationForm'] === null ? null : json['organizationForm'],
        'status': json['status'] == null ? undefined : ExternalUserStatusFromJSON(json['status']),
    };
}

export function ExternalUserResponseToJSON(json: any): ExternalUserResponse {
    return ExternalUserResponseToJSONTyped(json, false);
}

export function ExternalUserResponseToJSONTyped(value?: ExternalUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'displayName': value['displayName'],
        'email': value['email'],
        'firstName': value['firstName'],
        'surname': value['surname'],
        'mfaPhoneNumber': value['mfaPhoneNumber'],
        'organizationName': value['organizationName'],
        'organizationNumber': value['organizationNumber'],
        'organizationForm': value['organizationForm'],
        'status': ExternalUserStatusToJSON(value['status']),
    };
}

